import { IncomingMessage } from 'http';

import Cookies from 'universal-cookie';
import { ParsedUrlQuery } from 'querystring';

import { routes } from '@routes';

import { link } from '@utils/link';

export const getTokenPayload = (token: string) => {
  try {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
  } catch (e) {
    // return undefined
  }
  return;
};

export const parseLoginRedirectQuery = (redirectQuery?: ParsedUrlQuery) => {
  let parsedRedirect = link(routes.homepage);

  if (redirectQuery?.r && !Array.isArray(redirectQuery.r)) {
    try {
      parsedRedirect = JSON.parse(redirectQuery.r);
    } catch (err) {
      // parsing of the query failed, fallback to homepage
    }
  }

  return parsedRedirect;
};

export const createLoginRedirectUrl = (
  queryParams: string,
  url: URL,
  reason?: string,
) => {
  const redirectLink = {
    href: url.pathname + `?${queryParams}`,
  };
  const { as: redirectUrl } = link(
    routes.login,
    {},
    {
      r: JSON.stringify(redirectLink),
      reason,
    },
  );

  return redirectUrl as string;
};

const tokenCookieKey = 'access-token';
export const getTokenFromRequest = (req: IncomingMessage) => {
  const cookies = new Cookies(req.headers.cookie);
  const token: string = cookies.get(tokenCookieKey);
  return token;
};

export const getClientIp = (req: IncomingMessage) => {
  const forwarded = req.headers['x-forwarded-for'];
  return typeof forwarded === 'string'
    ? forwarded.split(/, /)[0]
    : req.socket.remoteAddress;
};
